var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67297 9.73061H14.352V12.0609C15.026 10.7207 16.7545 9.51647 19.3511 9.51647C24.3287 9.51647 25.5104 12.1844 25.5104 17.0794V26.145H20.4711V18.1942C20.4711 15.4066 19.7971 13.8345 18.0812 13.8345C15.7013 13.8345 14.7123 15.5287 14.7123 18.1929V26.145H9.67297V9.73061ZM1.03171 25.9309H6.07108V9.51647H1.03171V25.9309ZM6.79297 4.16424C6.79315 4.58657 6.70938 5.00472 6.54653 5.39439C6.38367 5.78407 6.14497 6.13749 5.84431 6.43412C5.23505 7.03953 4.41037 7.37841 3.55139 7.37633C2.69393 7.37576 1.87116 7.03774 1.261 6.43538C0.961424 6.13774 0.723533 5.78392 0.560961 5.3942C0.398388 5.00447 0.314328 4.5865 0.313599 4.16424C0.313599 3.31146 0.653756 2.49521 1.26226 1.8931C1.87188 1.28993 2.695 0.951772 3.55265 0.952149C4.41187 0.952149 5.2358 1.29099 5.84431 1.8931C6.45155 2.49521 6.79297 3.31146 6.79297 4.16424Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/LinkedinIcon.e2811c6a338482bacb95eeb27a47e039.svg";
export { ForwardRef as ReactComponent };